import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import AcceptChat from 'components/customer/composition/accept_chat_window';
import { AgentParticipantStatus } from 'models/routing_queue_item';
import ChatActions from './chat/chat_actions';
import ChatComposerButtons from './chat/composer_buttons';
import Composer, { Header, HeaderText, useComposer } from './shared/composer';
import ComposerContext from 'components/composer/contexts/composer_context';
import connect from 'components/lib/connect';
import { EditorContainer, useEditor } from './shared/editor';
import InteractionType from 'models/interaction_type';
import { isEditorEmpty } from 'components/text_editor/helpers';
import MessagingEditor from './editors/messaging';
import PlaintextSerializer from 'components/text_editor/serializers/plaintext_serializer';
import SendChat from 'actions/composer/send_chat';
import { useChatOnChange } from './chat/chat_hooks';

export function ChatComposerBase({ disableSubmit, shouldShowAcceptChat }) {
  const { composition } = useContext(ComposerContext);
  const composer = useComposer(SendChat);
  const onChange = useChatOnChange();
  const editorProps = useEditor('bodyHtml', composer, { attr: 'text', serializer: PlaintextSerializer, onChange });
  const [composerProps] = composer;

  let content = <AcceptChat />;
  let submitButton = null;

  if (!shouldShowAcceptChat) {
    content = (
      <EditorContainer includeAttachments>
        <MessagingEditor placeholder="Type to chat" {...editorProps} />
      </EditorContainer>
    );

    const { onSubmit } = composerProps;
    submitButton = (
      <ChatActions
        isEditorEmpty={isEditorEmpty(editorProps.value) && !composition.hasAttachments()}
        onSubmit={onSubmit}
      />
    );
  }

  return (
    <Composer
      includeAttachments
      disableSubmit={disableSubmit}
      submitButton={submitButton}
      submitText="Send"
      {...composerProps}
    >
      <Header>
        <HeaderText color="green400">Chat</HeaderText>
        <ChatComposerButtons {...editorProps} />
      </Header>
      {content}
    </Composer>
  );
}

ChatComposerBase.propTypes = {
  attachmentsEnabled: PropTypes.bool,
  disableSubmit: PropTypes.bool,
  shouldShowAcceptChat: PropTypes.bool,
};

export const ChatComposer = connect(mapStateToProps)(ChatComposerBase);

function mapStateToProps({ getProvider }) {
  let currentAgent = getProvider('currentAgent').get();
  let customer = getProvider('profile').get();
  let customerId = _.get(customer, 'id');
  let activeSessionsProvider = getProvider('activeSessions');

  return {
    disableSubmit: !isAgentExistingChatParticipant(),
    shouldShowAcceptChat: !isAgentExistingChatParticipant() && isOfferedForCurrentCustomer(),
  };

  function isOfferedForCurrentCustomer() {
    let activeSession = activeSessionsProvider.findBy({ customer: { id: customerId } });
    return !!(
      activeSession &&
      activeSession.queueItem.getSessionByType(InteractionType.CHAT) &&
      activeSession.queueItem.getAgentParticipantStatus(currentAgent.id) === AgentParticipantStatus.OFFERED
    );
  }

  function isAgentExistingChatParticipant() {
    let activeSession = activeSessionsProvider.findBy({ customer: { id: customerId } });
    return (
      activeSession &&
      activeSession.queueItem.getSessionByType(InteractionType.CHAT) &&
      activeSession.queueItem.getAgentParticipantStatus(currentAgent.id) === AgentParticipantStatus.ACTIVE
    );
  }
}

export default React.memo(ChatComposer);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/chat_composer.jsx